import React, { Component } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import CookieConsentComponent from '../../Components/CookieConsent'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { connect } from 'react-redux'
// import flwtInicio from '../../images/flwt_inicio.png'
import chart from '../../images/graph.svg'
import ranking from '../../images/ranking.svg'
import people from '../../images/people.svg'
import bars from '../../images/chart.svg'
import tag from '../../images/tag-2.svg'
import { Link } from 'react-router-dom'
import './flwt.css';
import CardFlwt from '../../Components/CardFlwt'

const items1 = [
    {
        icon: chart,
        text: "15% da receita total proveniente das conversões realizadas na carteira, distribuidos entre os token holders."
    },
    {
        icon: ranking,
        text: "Acesso antecipado à futuros lançamentos."
    }
]

const items2 = [
    {
        icon: people,
        text: "Comunidade exclusiva em nossos canais de comunicação."
    },
    {
        icon: bars,
        text: "Retornos expressivos através de Yield Farming seguro."
    },
    {
        icon: tag,
        text: "Whitelist preferencial para promoções e campanhas."
    }
]

class ProdutosFLWT extends Component {
    constructor() {
        super();
          this.state = {
          fillBackground: false,
        };
      }

    componentDidMount = async () => {
        const { onLoad, userid, logged } = this.props
        if(logged && onLoad && userid) {
            onLoad(userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        return (
            <div id="flwtSection">
                <Navbar fillBackground={this.state.fillBackground} />
                <div className="section sobreWrapper headerWrapper">
                    <Container>
                        <Row>
                            <Col md={12} className="bg-flwt">
                                <h2 className="pageCall  deskLeftMobileLeft widthTitleBannerFlwt">Faça parte da <span className="tx-pink">descentralização</span> crypto no Brasil</h2>
                                <p className="headerDescProducts deskLeftMobileLeft widthSubtitleBannerFlwt">Esqueça produtos complexos, aqui você <span className="tx-pink">mergulha em DeFi</span> de forma intuitiva.</p>
                                <Link to="/cadastro" className='anchorBtn mt-5'>Faça parte</Link>
                                <p className="headerDescProducts deskLeftMobileLeft subtitleFlwt widthBannerFlwt">Entre no universo DeFi da forma mais simples e segura: ao comprar FLWT você está construindo um ambiente mais democrático e descentralizado, tirando o poder de market makers e grandes exchanges e repassando o controle para os usuários.<br /><br />O Flow.in Wallet LP Token (FLWT) é um token de utilidade direcionado a criar liquidez para as operações de conversão entre R$ e Crypto.</p>
                            </Col>
                        </Row>
                    </Container>

                    <div className="backgroundWrapperCircle">
                        {/* <img src={flwtInicio} className="img-product"/> */}
                    </div>

                    <Container>
                        <Row className="mt-5">
                            <Col md={12} className="d-flex justify-content-center mt-5 mb-5">
                                <h2 className="text-white subtitlePages">Torne-se um <span className="tx-pink">token holder</span> de FLWT e tenha acesso à:</h2>
                            </Col>
                            <Col md={4} className="d-flex align-items-center justify-content-center">
                                <CardFlwt />
                            </Col>
                            <Col md={1}/>
                            <Col md={3} className="d-flex flex-column justify-content-around">
                                {items1.map(item => (
                                    <div className="flwtMobileWrapper">
                                        <img src={item.icon} />
                                        <p className="text-white">{item.text}</p>
                                    </div>
                                ))}
                            </Col>
                            <Col md={1}/>
                            <Col md={3} className="d-flex flex-column justify-content-between">
                                {items2.map(item => (
                                    <div className="flwtMobileWrapper">
                                        <img src={item.icon} />
                                        <p className="text-white">{item.text}</p>
                                    </div>
                                ))}
                            </Col>
                            <Col md={12} className="d-flex flex-column align-items-center buttonsFlwtWrapper">
                                <Link to="/cadastro" className='anchorBtn mt-4'>Torne-se um token holder FLWT agora</Link>
                                {/* <Link to="/Flowin%20Wallet%20LP%20Token-2.pdf" target="_blank" className="text-white mt-5">Acesse o whitepaper e saiba mais sobre o tokenomics do FLWT</Link> */}
                            </Col>
                        </Row>
                    </Container>
                </div>
                <CookieConsentComponent />
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ProdutosFLWT)